import React from 'react';
import PropTypes from 'prop-types';

import { ChirpButton } from 'javascripts/components/chirp_button';

import styles from 'stylesheets/components/play_audiobook_button.module';

export function PlayAudiobookButton({ userAudiobook }) {
  function renderPlayButton() {
    return (
      <ChirpButton
        attrs={{ target: '_blank' }}
        displayStyle='yellow'
        fullWidth
        href={userAudiobook.playable ? userAudiobook.playerUrl : null}
        isDisabled={!userAudiobook.playable}
        label='Start Listening'
      />
    );
  }

  function renderAudiobookStatusMessage() {
    if (_.isEmpty(userAudiobook)) {
      return null;
    }

    if (!userAudiobook.playable) {
      return <div className={styles.status}>Finalizing Purchase</div>;
    }

    if (userAudiobook.archived) {
      return (
        <div className={styles.status}>
          Audiobook has been removed from your library.
          <br />
          Add it back to your library&nbsp;
          <ChirpButton displayStyle='underline' displayType='link' fontSize='small' href='/library' label='here' />
        </div>
      );
    }

    return null;
  }

  return (
    <div className={styles.playAudiobookButton} data-testid='play-audiobook-button'>
      {renderPlayButton()}
      {renderAudiobookStatusMessage()}
    </div>
  );
}

PlayAudiobookButton.propTypes = {
  userAudiobook: PropTypes.shape({
    id: PropTypes.string,
    archived: PropTypes.bool,
    playable: PropTypes.bool,
    playerUrl: PropTypes.string,
  }),
};
